
import {useTranslation} from "react-i18next";
import {useEffect, useState} from 'react';
// material
import {
  Card,
  Stack,
  Container,
  Typography,
} from '@mui/material';
// components
import Page from '../../components/Page';
// mock
import ProductForm from "../../sections/@dashboard/constructions/ConstructionForm";



// ---------------------------------------------------------------------


const override = {
  // display: "block",
  margin: "0 auto",
  // borderColor: "red",
};


export default function SaveConstruction() {

  const { t, i18n } = useTranslation();
  
  
  useEffect(() => {
    i18n.changeLanguage("es")
  }, [])

  return (
    <Page title={t('construction_form')}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t('construction_form')}
          </Typography>
        </Stack>
        <Card style={{padding: "50px"}}>
         <ProductForm />
        </Card>
      </Container>
    </Page>
  );
}
